import React, { useEffect } from "react";
import { Spin } from "antd";
import { resolveNewFrontendHref } from "../../../app/navigation/new-frontend-href";

/**
 * 旧列表、新建、预警地址一律进新前端的同一路径。
 * 菜单已经指向新前端；收藏、手输和旧前端记住的上次路径也走这里。
 */
export default function VendorCrmEntryRedirect({ message = "正在打开新的供应商 CRM…" }) {
    useEffect(() => {
        const { pathname, search } = window.location;
        const marker = "/contract-management/vendor-crm";
        const start = pathname.indexOf(marker);
        const suffix = start >= 0 ? pathname.slice(start) : marker;
        window.location.replace(resolveNewFrontendHref(`${suffix}${search || ""}`));
    }, []);

    return (
        <div className="page-container">
            <div style={{ textAlign: "center", padding: 48 }}>
                <Spin />
                <div style={{ marginTop: 12 }}>{message}</div>
            </div>
        </div>
    );
}
